export default __webpack_public_path__ + "static/media/Background_00153.905abec9.png";